
























import { Component, Vue, Prop } from 'vue-property-decorator'
import { User } from '@/types/Users'
import { deleteUser } from '@/services/users'

@Component
export default class DeleteUserDialog extends Vue {
  @Prop({ default: false }) readonly opened!: boolean
  @Prop({ default: false }) loading!: boolean
  @Prop(Object) readonly user!: User

  closeDialog() {
    this.$emit('update:opened', false)
  }

  async deleteUser() {
    this.loading = true
    await deleteUser(this.$store, this.user.id)
    this.$router.push({name: 'users'})
    this.loading = false
    this.closeDialog()
  }
}
